export default function (): void {
  const el = document.getElementById('payment-schedule-toggle')

  if (el) {
    el.addEventListener('click', function () {
      ;(this.parentNode as HTMLElement).classList.toggle('schedule--closed')
    })
  }
}
